import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { PageWrapper } from '../solceller';
import useStore from '../../../../hooks/useStore';

import { VentilasjonsForm } from './form';
import { VentilasjonFormData } from './form/types';

export const Ventilasjon = () => {
  const { t } = useTranslation('', { keyPrefix: 'form.ventilasjon' });
  const store = useStore();
  const userInput = store.getState().register.userInput;

  const defaultValues: VentilasjonFormData = {
    ventilasjonType: userInput.ventilasjon?.ventilasjonType || null,
    gjenvinningAvVarme: userInput.ventilasjon?.gjenvinningAvVarme || null,
    gjenvinningsType: userInput.ventilasjon?.gjenvinningsType || null,
    installasjonsAr: userInput.ventilasjon?.installasjonsAr ? {
      installasjonsAr: userInput.ventilasjon?.installasjonsAr || undefined,
      vetInstallasjonsAr: userInput.ventilasjon?.vetInstallasjonsAr ?? undefined,
    } : null,
    serviceGjennomfortSiste2Ar: userInput.ventilasjon?.serviceGjennomfortSiste2Ar || null
  };

  return (
    <PageWrapper>
      <Heading data-size="lg" level={2}>
        {t('pageTitle')}
      </Heading>
      <Paragraph>{t('info')}</Paragraph>
      <VentilasjonsForm defaultValues={defaultValues} />
    </PageWrapper>
  );
};
